/** Cloudflare Turnstile's public site key. Empty turns the captcha off. */
export const TURNSTILE_SITE_KEY = (import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined) ?? '';
